export const styles = {
  errorContainer:
    'tw-bg-white tw-rounded-md tw-border tw-border-neutral-200 tw-overflow-hidden',
  error: 'tw-p-4 tw-text-danger-500 tw-text-center',
  nameContainer: 'tw-flex tw-items-center tw-gap-3',
  name: 'tw-font-medium tw-text-neutral-900',
  subCount: 'tw-text-sm tw-text-neutral-500',
};
